const all = ['patientStatistics']
const detail = (id: number) => [...all, id]

export const patientStatisticsKeys = {
  all,
  detail,
}
